import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const NoSearchResultIcon = () => (
  <ImageIcon src={Images.NoSearchResultIcon} alt="No Search Result" />
);

export default NoSearchResultIcon;
